import Grid from '@mui/material/Grid2'
import { Container, useMediaQuery } from '@mui/material'
import { useNavigate } from "react-router-dom";
import { Map, arrowRight, ChevronRight } from '../../helpers/constant/imageUrl'
import AtomButton from '../../atoms/button/button'
import { BREAK_POINT_CONSTANTS } from '../../helpers/constant/constant'
import './globalPresence.scss'

const GlobalPresenceTemplate = () => { 
    const navigate = useNavigate();
    const breakPoint = useMediaQuery(`(${BREAK_POINT_CONSTANTS.MOBIE})`)
    return (
        <div className="organization">
            <div className='gradient-section'>
                <Container className='container'>
                    <h1>Global Reach & Unmatched Support</h1>
                    <p>Our strategically positioned offices in Singapore, Basel, Bahnhofstraße, Luton, and New Jersey underscore our commitment to seamless service. Covering 80+ countries via robust distribution networks, we ensure unparalleled accessibility worldwide.</p>
                    <AtomButton 
                        variant = {'outlined'}
                        size = {'small'}
                        className='btn mb-5 mb-md-0'
                    >
                        <span className='icon'>
                            <img src={arrowRight} alt='arrowRight' />
                        </span>
                        <div>
                            Strategic Office Locations
                            <strong>Seamless Client Support Worlwide</strong>
                        </div>
                    </AtomButton>
                    <AtomButton 
                        variant = {'outlined'}
                        size = {'small'}
                        className='btn'
                    >
                        <span className='icon'>
                            <img src={arrowRight} alt='arrowRight' />
                        </span>
                        <div>
                            Extensive Export Network
                            <strong>Robust Distribution in 80+ Countries</strong>
                        </div>
                    </AtomButton>
                    <img src={Map} alt='Map' className='map' />
                </Container>
            </div>
            <div className='discover-offices'>
                <Container className='container'>
                    <Grid
                        container
                        direction="row"
                        spacing={{ xs: 5, md: 0 }}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Grid size={{ xs: 12, md: 9 }}>
                            <h6>
                                Discover Our Global Reach: Find Country - Specific Contact Information
                            </h6>
                        </Grid>
                        <Grid size={{ xs: 12, md: 'auto' }}>
                            <AtomButton 
                                variant = {'outlined'}
                                size = {'large'}
                                endIcon={
                                    <img src={ChevronRight} alt='ChevronRight' />
                                }
                                onClick={()=>navigate("/contact-us")}
                            >
                                global offices
                            </AtomButton>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </div>
    )
}

export default GlobalPresenceTemplate